import { Component, OnInit } from '@angular/core';
import { faConciergeBell, faListAlt, faStore, faQuestionCircle, faChartBar, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { HomeComponent } from '../home/home.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  faConciergeBell = faConciergeBell;
  faListAlt = faListAlt;
  faStore = faStore;
  faQuestionCircle = faQuestionCircle;
  faChartBar = faChartBar;
  faChartLine = faChartLine;

  currentScreen = 'order';
  
  constructor() { }

  ngOnInit() { }

  setScreen(screen) {
    this.currentScreen = screen;
    HomeComponent.screenListener.emit(screen);
  }

}
